import { useEffect, useState } from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

import { collection, getDocs } from "firebase/firestore";

import { useAuth } from "../../contexts/AuthContext";
import { db } from "../../firebase";

const colors = ["#1f2937", "#d4a411", "#64748b", "#22c55e", "#f97316", "#0ea5e9"];

const ServiceTypeChart = () => {
  const { currentUser } = useAuth();
  const [serviceTypes, setServiceTypes] = useState([]);

  useEffect(() => {
    const fetchServiceTypes = async () => {
      const typeCounts = {}; // Compteur pour chaque type de prestation

      // Récupération des données de `catalog` pour créer un mapping des types
      const catalogSnapshot = await getDocs(collection(db, `users/${currentUser.uid}/catalog`));
      const catalogTypeMapping = {};

      catalogSnapshot.forEach(doc => {
        const catalogData = doc.data();
        catalogTypeMapping[doc.id] = catalogData.type; // Associe le `catalog_id` à son type
      });

      // Récupération des commandes validées et calcul du nombre de chaque type de prestation
      const ordersSnapshot = await getDocs(collection(db, `users/${currentUser.uid}/orders`));
      ordersSnapshot.forEach(doc => {
        const order = doc.data();

        // Ne tenir compte que des prestations validées
        if (order.orderIsConfirmed) {
          const type = catalogTypeMapping[order.catalog_id] || "Type inconnu";
          typeCounts[type] = (typeCounts[type] || 0) + 1;
        }
      });

      // Formater les données pour le graphique
      setServiceTypes(
        Object.entries(typeCounts).map(([name, value]) => ({ name, value }))
      );
    };

    fetchServiceTypes();
  }, [currentUser]);

  return (
    <ResponsiveContainer width="100%" height={320}>
      <PieChart>
        <Pie
          data={serviceTypes}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={100}
          innerRadius={58}
          labelLine={false}
        >
          {serviceTypes.map((item, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Pie>
        <Tooltip formatter={value => Number(value || 0).toLocaleString("fr-FR")} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default ServiceTypeChart;
